import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-aoda',
    templateUrl: './aoda.component.html',
    styleUrls: ['./aoda.component.scss'],
    standalone: false
})
export class AodaComponent implements OnInit 
{

  constructor(
    public translateService: TranslateService
  ) 
  { 
  }

  ngOnInit() 
  {
  }

}
